const openStore = async (storeUrl) => {
    if (!storeUrl) return;
    const { App } = await import('@capacitor/app');
    await App.openUrl({ url: storeUrl });
};

// Tela bloqueante para quem está abaixo da versão mínima suportada — sem
// opção de dispensar, porque o app não pode garantir compatibilidade com a
// API abaixo desse ponto (ver GET /public/app-version).
export const UpdateRequiredScreen = ({ storeUrl }) => (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-background px-6 text-center">
        <h1 className="text-xl font-bold text-on-background">Atualize o CatholicGPT para continuar</h1>
        <p className="max-w-sm text-sm text-on-surface-variant">
            Esta versão do app não é mais compatível. Atualize para a versão mais recente para continuar usando.
        </p>
        <button
            type="button"
            onClick={() => openStore(storeUrl)}
            className="min-h-[44px] rounded-lg bg-primary px-6 py-2 font-semibold text-on-primary"
        >
            Atualizar agora
        </button>
    </div>
);

// Faixa dispensável para quem está numa versão mais antiga que a mais
// recente, mas ainda dentro do suportado. Reaparece a cada versão nova
// (controlado por dismissUpdateAvailable em useNativeShell).
export const UpdateAvailableBanner = ({ storeUrl, onDismiss }) => (
    <div className="fixed top-0 inset-x-0 z-[60] pt-safe-top bg-primary text-on-primary text-sm py-2 px-4 flex items-center justify-center gap-3">
        <span>Uma nova versão do CatholicGPT está disponível.</span>
        <button type="button" onClick={() => openStore(storeUrl)} className="min-h-[44px] font-bold underline">
            Atualizar
        </button>
        <button type="button" onClick={onDismiss} aria-label="Dispensar" className="min-w-[44px] min-h-[44px] font-bold">
            ×
        </button>
    </div>
);
